var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Prop, Vue, } from "vue-property-decorator";
let CollapsingElement = class CollapsingElement extends Vue {
    onClick() { }
    get collapsedStateClass() { return "fas fa-chevron-" + (this.collapsed ? "right" : "down"); }
    get animationStyle() { return this.animate ? "animation-delay: " + (1000 + 50 * this.index).toString() + "ms" : ""; }
};
__decorate([
    Prop({ required: true })
], CollapsingElement.prototype, "animate", void 0);
__decorate([
    Prop({ required: true })
], CollapsingElement.prototype, "collapsed", void 0);
__decorate([
    Prop({ required: true })
], CollapsingElement.prototype, "index", void 0);
__decorate([
    Emit()
], CollapsingElement.prototype, "onClick", null);
CollapsingElement = __decorate([
    Component({
        components: {},
        name: "CollapsingElement",
    })
], CollapsingElement);
export default CollapsingElement;
